import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { FilterService } from 'src/app/services/filter.service';
import { StaffService } from 'src/app/services/staff/staff.service';
import { UtilityService } from 'src/app/services/utility.service';

@Component({
  selector: 'pending-staff',
  templateUrl: './pending-staff.component.html',
  styleUrls: ['./pending-staff.component.scss']
})
export class PendingStaffComponent implements OnInit {

  @Input('userList') userListData
  @Output() actionData: EventEmitter<any> = new EventEmitter<any>();
  dataSource: MatTableDataSource<any>;
  paginator: MatPaginator;
  sort: MatSort;
  pageSizeOptions: number[] = [25, 50, 100];
  displayedPendingUsersColumns: string[] = ['fullname', 'email', 'submission', 'actions'];

  pendingUserList = []
  pendingUserListCopy = []
  pendingUserData
  noPendingDataMsg = {
    title: "No Pending Users!",
    data: "No users are waiting for approval"
  }
  _isDisplay = false
  filterActive: Boolean = false;
  afterFilter: any;
  searchText
  isSpinnerId
  isSpinner: boolean = false

  @ViewChild(MatSort, { static: true }) set matSort(ms: MatSort) {
    this.sort = ms;
    this.setDataSourceAttributes();
  }
  @ViewChild(MatPaginator, { static: false }) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
    this.setDataSourceAttributes();
  }

  setDataSourceAttributes() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  constructor(
    public _filter: FilterService,
    public _staffService: StaffService,
    public _utilityService: UtilityService,
    public _cd : ChangeDetectorRef
  ) {
    this.dataSource = new MatTableDataSource();
  }

  ngOnInit(): void {
  }


  ngOnChanges(changes: SimpleChanges): void {
    console.log("CHANGES OF PENDING USER LIST", changes)
    if (changes.userListData && changes.userListData.currentValue) {
      this.pendingUserList = changes.userListData.currentValue
      this.updateData(this.pendingUserList)
    }

  }


  // UTILITY

  updateData(instructors) {
    console.log("UPDATING DATA = ", instructors)
    this.dataSource = new MatTableDataSource(instructors);
    this.dataSource.sortingDataAccessor = (item, property) => {
      // console.log("item=====>>>>>", item);
      // console.log("property=====>>>>>", property);
      switch (property) {
        case 'fullname': return item.details.personlDetails.fullName;
        case 'submission': return item.createdAt
        default:
          break;
      }
    }
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    console.log("SETTING SORT TO = ", this.dataSource.sort)
    console.log("SETTING paginator TO = ", this.dataSource.paginator)
    // this.paginator._changePageSize(instructors.length)
  }

  viewPendingUser(user) {
    this.pendingUserData = user
    console.log("VIEW SINLGE USER DATA", this.pendingUserData)
    this._isDisplay = true
  }


  closeForm(event) {
    this.pendingUserData = null
    this._isDisplay = false
  }

  approveOrRejectEvent(event) {
    console.log("EVENT OF APPROVE OR REJECT", event)
    if (event === 'approve') this.approveUser(this.pendingUserData)
    if (event === 'reject') this.notApprovedUser(this.pendingUserData)
    // this.pendingUserData = null
    // this._isDisplay = false
    // this._cd.detectChanges()
  }

  approveUser(userData) {
    this.actionData.emit({ action: 'approve', data: userData })
  }

  notApprovedUser(userData) {
    this.actionData.emit({ action: 'reject', data: userData })
  }


  filter(searchText) {
    this.filterActive = true;
    if (searchText === '') {
      this.updateData(this.pendingUserList);
      this.filterActive = false;
    }
    let pendingList = this.pendingUserList
    let filteredIns = this._filter.staffFilterService(searchText, pendingList, ['fullName', 'newSentinelNumber']);
    console.log("FILTERED", filteredIns)
    this.updateData(filteredIns);
    if (filteredIns.length <= 0) {
      this.afterFilter = {
        title: "No Pending Users!",
        data: "Sorry, no member matched your search"
      }
    } else {
      this.filterActive = false
    }
  }


  // API CALL



  downloadSponsorPack(data) {
    this.isSpinnerId = data._id;
    this.isSpinner = true
    console.log("DATA OF PACK", data)
    this._staffService.downloadSponsorPack(data._id, false).subscribe((res) => {
      console.log("DOWNLOAD RES", res)
      if (res) {
        const downloadLink = document.createElement("a");
        // const fileName = moment(new Date(obj.submissionDate)).format("MM-DD-YYYY") + ".pdf";
        downloadLink.href = res;
        // downloadLink.download = fileName;
        downloadLink.click();
        this._utilityService.handleSnackBar({ msg: "File downloaded successfully!", button: "Ok" })
      }
      this.isSpinner = false;
      this.isSpinnerId = null
    }, error => {
      console.log("EROR WHILE DOWNLOAD", error)
      this._utilityService.handleSnackBar({ msg: error.msg, button: "Ok" })
      this.isSpinner = false
      this.isSpinnerId = null
    })
  }
}
